import {  useEffect, useState } from "react";
import { RootState } from "../../../redux/rootReducers";
import toast, { Toaster } from "react-hot-toast";
import { connect } from "react-redux";
import { resetSession } from "../../../redux/auth";
import {
  checkUniqueBranchNameAction,
  createMasterDataScopeOfWorkAction,
  deleteMasterDataScopeOfWorkAction,
  getMasterDataScopeOfWorkAction,
  resetIsBranchName,
  resetMasterError,
  resetMasterMessage,
  resetMasterStatusCode,
  resetMasterSuccess,
  resetScopeOfWorkList,
  resetScopeTotalCount,
  updateMasterDataScopeOfWorkAction,
} from "../../../redux/masterData";
import { EmptyList } from "../../../assets/images";
import {
    AddScopeOfWorkPayloadType,
  AddUsersDepartmentPayloadType,
  DeleteScopeOfWorkPayloadType,
  DeleteUsersDepartmentPayloadType,
  GetUsersDepartmentPayloadType,
  UpdateScopeOfWorkPayloadType,
} from "../../../commonTypes/masterDataTypes";
import { SearchIcon } from "../../../components/Icon";
import useDebounce from "../../../customHooks/useDebounce";
import {
  CommonHeader,
  ConfirmationModal,
  EmptyListPage,
  ErrorSuccessModal,
  TableLoader,
} from "../../../components/commons";
import MasterDataCommonTable from "../../../components/MasterData/MasterDataCommonTable/MasterDataCommonTable";
import { SCOPE_OF_WORK_HEADERS } from "../../../constant/tableHeadersConstants/masterDataContants/masterDataClientGroupListConst";
import AddEditMasterModuleModal from "../../../components/MasterData/AddEditMasterModuleModal";
import { useMenuCheck } from "../../../customHooks/useMenuCheck";
import { ScopeOfWorkListType } from "../../../redux/masterData/masterTypes";
 
type AppProps = {
  history: any;
  fetching: boolean;
  message: string;
  success: null | number;
  error: null | string;
  statusCode: null | number;
  isOpen: boolean;
  token: null | string;
  scopeOfWorkList: ScopeOfWorkListType[] | [];
  scopeOfWorkTotalCount: number;
  dispatchResetMasterStatusCode: () => void;
  dispatchResetSession: () => void;
  dispatchResetScopeOfWorkList: () => void;
  dispatchResetScopeTotalCount: () => void;
  dispatchResetMasterSuccess: () => void;
  dispatchResetMasterMessage: () => void;
  dispatchResetMasterError: () => void;
  dispatchGetMasterDataScopeOfWorkAction: (
    data: GetUsersDepartmentPayloadType
  ) => void;
  dispatchAddMasterDataScopeOfWorkAction: (data: AddScopeOfWorkPayloadType) => void;
  dispatchUpdateMasterDataScopeOfWorkAction: (data: UpdateScopeOfWorkPayloadType) => void;
  dispatchDeleteMasterDataScopeOfWorkAction: (data: DeleteScopeOfWorkPayloadType) => void;
  dispatchCheckUniqueScopeOfWorkNameAction: (
    data: DeleteUsersDepartmentPayloadType
  ) => void;
  dispatchResetUniqueCheckAction: () => void;
  isScopeOfWorkName: any;
  uniqueCheckFetching: boolean;
};
const ScopeOfWork = ({
  fetching,
  message,
  success,
  error,
  token,
  statusCode,
  dispatchResetMasterError,
  dispatchResetScopeOfWorkList,
  dispatchResetSession,
  dispatchResetScopeTotalCount,
  dispatchResetMasterSuccess,
  dispatchResetMasterMessage,
  dispatchResetMasterStatusCode,
  scopeOfWorkList,
  scopeOfWorkTotalCount,
  dispatchGetMasterDataScopeOfWorkAction,
  dispatchAddMasterDataScopeOfWorkAction,
  dispatchUpdateMasterDataScopeOfWorkAction,
  dispatchDeleteMasterDataScopeOfWorkAction,
  dispatchCheckUniqueScopeOfWorkNameAction,
  isScopeOfWorkName,
  dispatchResetUniqueCheckAction,
  uniqueCheckFetching,
}: AppProps) => {
  const [showAddEditMasterDataModal, setShowAddEditMasterDataModal] =
    useState<boolean>(false);
  const [showDeleteConfirmationModal, setShowDeleteConfirmationModal] =
    useState<boolean>(false);
  const [scopeOfWorkError, setScopeOfWorkError] = useState<string>("");
  const [scopeName, setScopeName] = useState<string>("");
  const [data, setData] = useState<any[]>([]);
  const [refresh, setRefresh] = useState<boolean>(false);
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [id, setId] = useState<string | null | undefined>(null);
  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(20);
  const [status, setStatus] = useState(true);
  const [searchValue, setSearchValue] = useState("");
  const [deleteId, setDeleteId] = useState("");
 
  //====================User Management=============================
  const [isAddScopeOfWorkPresent, setIsAddScopeOfWorkPresent] = useMenuCheck();
  const [isEditScopeOfWorkPresent, setIsEditScopeOfWorkPresent] =
    useMenuCheck();
  const [isDeleteScopeOfWorkPresent, setIsDeleteScopeOfWorkPresent] =
    useMenuCheck();
  const [isGetScopeOfWorkPresent, setIsGetScopeOfWorkPresent] = useMenuCheck();
  //=================================================================
 
  useEffect(() => {
    window.scroll({
      top: 0,
      left: 0,
    });
    setIsAddScopeOfWorkPresent("Add Scope Of Work", "menu");
    setIsEditScopeOfWorkPresent("Update Scope Of Work", "menu");
    setIsDeleteScopeOfWorkPresent("Delete Scope Of Work", "menu");
    setIsGetScopeOfWorkPresent("Get Scope Of Work List", "menu");
    dispatchResetMasterSuccess();
    dispatchResetMasterError();
    dispatchResetMasterMessage();
    dispatchResetScopeOfWorkList();
    dispatchResetScopeTotalCount();
    dispatchResetMasterStatusCode();
  }, []);
  useEffect(() => {
    if (scopeOfWorkList?.length === 0) {
      setData(scopeOfWorkList);
    }
    if (offset > 0) {
      setData((prv: any) => [...prv, ...scopeOfWorkList]);
    } else {
      setData(scopeOfWorkList);
    }
  }, [scopeOfWorkList]);
 
  useEffect(() => {
    dispatchResetMasterSuccess();
    dispatchResetMasterMessage();
    dispatchResetMasterError();
    if (token) {
      let finalData: GetUsersDepartmentPayloadType = {
        token,
        limit,
        offset,
        searchValue,
      };
 
      if (scopeOfWorkTotalCount) {
        if (offset < scopeOfWorkTotalCount) {
          dispatchGetMasterDataScopeOfWorkAction(finalData);
        }
      } else {
        dispatchGetMasterDataScopeOfWorkAction(finalData);
      }
    }
  }, [offset]);
 
  useEffect(() => {
    if (!showAddEditMasterDataModal) {
      setIsEdit(false);
    }
  }, [showAddEditMasterDataModal]);
 
  useEffect(() => {
    if (offset === 0) {
      window.scrollTo(0, 0);
    } else {
      window.scrollTo(0, 0);
      setOffset(0);
    }
  }, [success]);
 
  useDebounce(
    () => {
      if (searchValue) {
        fetchNewData();
      } else {
        dispatchResetMasterSuccess();
        dispatchResetMasterMessage();
        let finalData: any = {
          token,
          limit,
          offset,
          searchValue,
        };
        dispatchGetMasterDataScopeOfWorkAction(finalData);
      }
    },
    500,
    [searchValue]
  );
 
  useDebounce(
    () => {
      dispatchResetUniqueCheckAction();
      if (scopeName) {
        let finalData: any = {
          token,
          operation: isEdit ? "update" : "add",
          name: scopeName?.trim(),
          unique_check: "scope_of_work",
          data_id: isEdit ? id : "",
        };
        dispatchCheckUniqueScopeOfWorkNameAction(finalData);
      }
    },
    500,
    [scopeName]
  );
  const fetchNewData = () => {
    dispatchResetMasterSuccess();
    dispatchResetMasterMessage();
    dispatchResetScopeOfWorkList();
    if (token) {
      let finalData = {
        token,
        searchValue,
        limit,
        offset,
      };
      if (offset === 0) {
        dispatchGetMasterDataScopeOfWorkAction(finalData);
      } else {
        setOffset(0);
      }
    }
  };
 
  const handleToogleStatusChange = () => {
    if (isEdit) {
      setStatus(!status);
    } else {
      setStatus(true);
    }
  };
  const handleScopeOfWorkNameChange = (e: any) => {
    setScopeName(e.target.value);
  };
 
  const toggleAddEditScopeOfWorkModal = () => {
    if (!showAddEditMasterDataModal) {
      handleResetData();
    }
 
    setShowAddEditMasterDataModal(!showAddEditMasterDataModal);
  };
 
  const handleResetData = () => {
    setScopeName("");
    setStatus(true);
    setOffset(0);
  };
 
  const handleEditMasterDataScopeOfWork = (data: any) => {
    setIsEdit(true);
    setShowAddEditMasterDataModal(true);
    setScopeName(data?.scope_of_work_name);
    setStatus(data?.status);
    setId(data?._id);
  };
 
  const handleSearch = (e: any) => {
    dispatchResetMasterSuccess();
    dispatchResetMasterMessage();
    let value = e.target.value;
    setSearchValue(value);
 
    if (value?.length === 0) {
      let finalData = {
        offset: 0,
        limit,
        token,
      };
      dispatchGetMasterDataScopeOfWorkAction(finalData);
    }
  };
 
  const handleAddAndUpdate = () => {
    dispatchResetMasterSuccess();
    dispatchResetMasterMessage();
    setRefresh(!refresh);
    dispatchResetMasterStatusCode();
    if (isEdit) {
      let updateData = {
        token: token,
        scopeOfWorkName: scopeName?.trim(),
        status: status == true ? 1 : 0,
        _id: id,
      };
      dispatchUpdateMasterDataScopeOfWorkAction(updateData);
    } else {
      let finalAddData = {
        token,
        scopeOfWorkName: scopeName?.trim(),
        status: status == true ? 1 : 0,
      };
      dispatchAddMasterDataScopeOfWorkAction(finalAddData);
      setSearchValue("");
    }
 
    let finalData = {
      token,
      limit,
      offset,
      searchValue,
    };
    if (offset === 0) {
      dispatchGetMasterDataScopeOfWorkAction(finalData);
    } else {
      setOffset(0);
    }
  };
 
  const onScroll = () => {
    if (!fetching) {
      const scrollTop = document.documentElement.scrollTop;
      const scrollHeight = document.documentElement.scrollHeight;
      const clientHeight = document.documentElement.clientHeight;
 
      if (
        offset < scopeOfWorkTotalCount &&
        !fetching &&
        Math.ceil((75 / 100) * scrollHeight) <= scrollTop + clientHeight
      ) {
        if (scopeOfWorkList?.length > 0) {
          if (!fetching && offset < scopeOfWorkTotalCount) {
            setOffset(offset + limit);
          }
        }
      }
    }
  };
 
  useEffect(() => {
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, [scopeOfWorkList]);
 
  const DeleteUsersDepartment = (deleteId: string) => {
    if (token && deleteId) {
      const finalData = {
        token,
        scopeOfWorkID: deleteId,
      };
      dispatchDeleteMasterDataScopeOfWorkAction(finalData);
    }
  };
 
  const handleDeleteConfirmationModal = () => {
    setShowDeleteConfirmationModal(!showDeleteConfirmationModal);
  };
 
  const handleDelete = (id: string) => {
    setDeleteId(id);
    setShowDeleteConfirmationModal(true);
  };
  const handleErrorModal = () => {
    if (success === 0) {
      if (
        success === 0 &&
        (error?.includes("Cannot Delete! Scope of work is Mapped to Clients.") ||
          error?.includes("You cannot Deactivate Scope of work, as it is Mapped to Clients."))
      ) {
        toast.error(
          error?.includes("Cannot Delete! Scope of work is Mapped to Clients.")
            ? "Cannot Delete! Scope of work is Mapped to Clients."
            : "Cannot Disabale! Scope of work is Mapped to Clients.",
          {
            duration: 2000,
          }
        );
        let finalData = {
          token,
          limit,
          offset,
          searchValue,
        };
        if (offset === 0) {
          dispatchGetMasterDataScopeOfWorkAction(finalData);
        }
 
      }
      dispatchResetMasterSuccess();
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={statusCode}
          />
        );
      } else if (!!error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetMasterError();
            }}
          />
        );
      }
    }
    if (success === 1 && message?.includes("added successfully!")) {
      dispatchResetScopeOfWorkList();
      dispatchResetMasterSuccess();
      dispatchResetMasterMessage();
      toast.success("Scope of work has been added successfully!", {
        duration: 2000,
      });
      let finalData = {
        token,
        limit,
        offset,
        searchValue,
      };
      if (offset === 0) {
        dispatchGetMasterDataScopeOfWorkAction(finalData);
      }
    }
    if (success === 1 && message?.includes("updated successfully!")) {
      dispatchResetScopeOfWorkList();
      dispatchResetMasterSuccess();
      dispatchResetMasterMessage();
      toast.success("Scope of work has been updated successfully!", {
        duration: 2000,
      });
      let finalData = {
        token,
        limit,
        offset,
        searchValue,
      };
      if (offset === 0) {
        dispatchGetMasterDataScopeOfWorkAction(finalData);
      }
    }
    if (success === 1 && message?.includes("deleted successfully!")) {
      dispatchResetScopeOfWorkList();
      dispatchResetMasterSuccess();
      dispatchResetMasterMessage();
      toast.success("Scope of work has been deleted successfully!", {
        duration: 2000,
      });
      let finalData = {
        token,
        limit,
        offset,
        searchValue,
      };
      if (offset === 0) {
        dispatchGetMasterDataScopeOfWorkAction(finalData);
      }
    }
    return false;
  };
 
  return (
    <div className="row">
      <div className="col-md-6">
        <CommonHeader title="Scope of Work" />
      </div>
      <div className="col-md-12">
        <div className="jobs-card">
          <div className="header">
            <div className="left-header">
              <div className="heading">Scope of Work List</div>
              {!fetching && scopeOfWorkTotalCount > 0 && (
                <div
                  className="sub-heading"
                  style={{ marginTop: "-22px" }}
                >{`Total ${
                  scopeOfWorkTotalCount ? scopeOfWorkTotalCount : 0
                } list found`}</div>
              )}
            </div>
            <div className="right-header">
              <div
                className={`${
                  !!scopeOfWorkList?.length ? "col-md-6" : "col-md-10"
                } position-relative`}
              >
                <span
                  style={{ position: "absolute", top: "8px", left: "25px" }}
                >
                  <SearchIcon />
                </span>
                <input
                  className="form-control"
                  type="text"
                  placeholder="Search"
                  onChange={(e) => handleSearch(e)}
                  style={{ paddingLeft: "35px" }}
                  value={searchValue}
                />
              </div>
 
              {isAddScopeOfWorkPresent && !!scopeOfWorkList?.length && (
                <button
                  className="btn btn-primary"
                  onClick={toggleAddEditScopeOfWorkModal}
                >
                  + Add Scope of Work
                </button>
              )}
            </div>
          </div>
          <div>
            {fetching && offset == 0 ? (
              <TableLoader Rows={10} ColumnPerRow={7} />
            ) : scopeOfWorkList?.length > 0 ? (
              <MasterDataCommonTable
                data={data}
                handleEditMasterData={handleEditMasterDataScopeOfWork}
                fetching={fetching}
                offset={offset}
                tableHeader={SCOPE_OF_WORK_HEADERS}
                handleDelete={handleDelete}
                isEditPresent={isEditScopeOfWorkPresent}
                isDeletePresent={isDeleteScopeOfWorkPresent}
                type={"scopeOfWork"}
              />
            ) : (
              <div className="mt-5 pb-5">
                {!fetching && data?.length === 0 && (
                  <EmptyListPage
                    title="No Scope of Work List Found!"
                    image={EmptyList}
                    imageWidth="30%"
                    showAddButton={isAddScopeOfWorkPresent}
                    buttonTitle={
                      isAddScopeOfWorkPresent ? "+ Add Scope of Work" : ""
                    }
                    onButtonClick={toggleAddEditScopeOfWorkModal}
                  />
                )}
              </div>
            )}
          </div>
        </div>
      </div>
      {showAddEditMasterDataModal && (
        <AddEditMasterModuleModal
          showAddEditMasterDataModal={showAddEditMasterDataModal}
          toggleAddEditMasterDataModal={toggleAddEditScopeOfWorkModal}
          isEdit={isEdit}
          inputFieldName={scopeName}
          inputFieldError={scopeOfWorkError}
          handleAddAndUpdate={handleAddAndUpdate}
          handleInputChange={handleScopeOfWorkNameChange}
          handleToogleStatusChange={handleToogleStatusChange}
          status={status}
          fieldLabel={"Scope of Work Name"}
          UpdateButtonName={"Update Scope of Work Name"}
          AddButtonName={"Add Scope of Work Name"}
          inputUniqueCheck={isScopeOfWorkName}
          fetching={uniqueCheckFetching}
          modalHeader={"Scope of Work"}
          toggleStatus={true}
          UniqueCheckErrorMessage={"Scope of Work Name is already in use!"}
          type={"scopeOfWork"}
        />
      )}
 
      {showDeleteConfirmationModal && (
        <ConfirmationModal
          toggle={() => {
            handleDeleteConfirmationModal();
          }}
          isOpen={showDeleteConfirmationModal}
          title={`Delete Scope of Work?`}
          message={`Are you sure you want to Delete?`}
          confirmButtonText="Delete"
          onPressConfirm={() => {
            DeleteUsersDepartment(deleteId);
            handleDeleteConfirmationModal();
          }}
        />
      )}
      {handleErrorModal()}
      <Toaster />
    </div>
  );
};
 
const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  fetching: state.masterData.fetching,
  statusCode: state.masterData.statusCode,
  error: state.masterData.error,
  scopeOfWorkList: state.masterData.scopeOfWorkList,
  scopeOfWorkTotalCount: state.masterData.scopeOfWorkTotalCount,
  success: state.masterData.success,
  message: state.masterData.message,
  isScopeOfWorkName: state.masterData.isBranchName,
  uniqueCheckFetching: state.masterData.branchFetching,
});
 
const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetMasterSuccess: () => dispatch(resetMasterSuccess()),
  dispatchResetMasterError: () => dispatch(resetMasterError()),
  dispatchResetMasterMessage: () => dispatch(resetMasterMessage()),
  dispatchResetScopeOfWorkList: () => dispatch(resetScopeOfWorkList()),
  dispatchResetScopeTotalCount: () => dispatch(resetScopeTotalCount()),
  dispatchResetMasterStatusCode: () => dispatch(resetMasterStatusCode()),
  dispatchGetMasterDataScopeOfWorkAction: (
    data: GetUsersDepartmentPayloadType
  ) => dispatch(getMasterDataScopeOfWorkAction(data)),
  dispatchAddMasterDataScopeOfWorkAction: (data: AddScopeOfWorkPayloadType) =>
    dispatch(createMasterDataScopeOfWorkAction(data)),
  dispatchUpdateMasterDataScopeOfWorkAction: (data: UpdateScopeOfWorkPayloadType) =>
    dispatch(updateMasterDataScopeOfWorkAction(data)),
  dispatchDeleteMasterDataScopeOfWorkAction: (data: DeleteScopeOfWorkPayloadType) =>
    dispatch(deleteMasterDataScopeOfWorkAction(data)),
  dispatchCheckUniqueScopeOfWorkNameAction: (data: any) =>
    dispatch(checkUniqueBranchNameAction(data)),
  dispatchResetUniqueCheckAction: () => dispatch(resetIsBranchName()),
});
 
export default connect(mapStateToProps, mapDispatchToProps)(ScopeOfWork);